/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPaymentDto } from '../../models/backend-payment-dto';
import { BackendPaymentRequestDto } from '../../models/backend-payment-request-dto';

export interface SubscriptionPaymentCreate$XWwwFormUrlencoded$Params {
  body?: BackendPaymentRequestDto;
}

export function subscriptionPaymentCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionPaymentCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendPaymentDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionPaymentCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendPaymentDto>;
    }),
  );
}

subscriptionPaymentCreate$XWwwFormUrlencoded.PATH = '/api/subscription/payment/';
